import { render } from "./AreaScores.vue?vue&type=template&id=29a85aec&ts=true"
import script from "./AreaScores.vue?vue&type=script&lang=ts"
export * from "./AreaScores.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__